import { render, staticRenderFns } from "./stock-import.vue?vue&type=template&id=684cee24&scoped=true"
import script from "./stock-import.vue?vue&type=script&lang=js"
export * from "./stock-import.vue?vue&type=script&lang=js"
import style0 from "./stock-import.vue?vue&type=style&index=0&id=684cee24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cee24",
  null
  
)

export default component.exports